import { CrmExperienceOption } from 'signup-constants/signupData/CrmExperienceOption';
import { HubInterestOption } from 'signup-constants/signupData/HubInterestOption';
import { JobFieldOption } from 'signup-constants/signupData/JobFieldOption';
import { FlowManager } from '../../flow-management/FlowManager';
import { Data } from '../../signup-data/DATA';
import { bulkSetSignupDataAndSetValid, setSignupDataCompleted } from '../../store/signup-data/action-creators';
import { getIsActiveAndAssignedToVariant, isExperimentActive } from '../../store/experiments/selectors';
import logExposure from '../logExposure';
import { ExperimentKeys } from '../ExperimentKeys';
import { Step } from '../../views/Step';
export const BIAB001RemoveSteps = {
  name: 'BIAB001RemoveSteps',
  stateCheck: (state, dispatch) => {
    const shouldSkipSurveyForBIAB001 = getIsActiveAndAssignedToVariant(state, ExperimentKeys.BIAB001);

    if (isExperimentActive(state, ExperimentKeys.BIAB001)) {
      dispatch(logExposure(ExperimentKeys.BIAB001));
    }

    if (shouldSkipSurveyForBIAB001) {
      dispatch(bulkSetSignupDataAndSetValid({
        [Data.CrmExperienceLevel]: CrmExperienceOption.None,
        [Data.HubInterest]: HubInterestOption.Marketing,
        [Data.JobField]: JobFieldOption.Marketing
      }));
      dispatch(setSignupDataCompleted(Data.CrmExperienceLevel));
      dispatch(setSignupDataCompleted(Data.HubInterest));
      dispatch(setSignupDataCompleted(Data.JobField));
    }

    return shouldSkipSurveyForBIAB001;
  },
  rebuildFlow: FlowManager.removeSteps(Step.CrmExperienceLevel, Step.HubInterest)
};